import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/store";
import { SocketEvents } from "../hooks/useSocket/types";
import Input from "../SideBar/Dialogue/Inputs/Input";
import NameIcon from "../../assets/NameIcon.svg";

const FullNameModal = () => {
	const { t } = useTranslation();
	const status = useStore((state) => state.status);
	const listenerFullName = useStore((state) => state.listenerFullName);
	const setListenerFullName = useStore((state) => state.setListenerFullName);
	const socket = useStore((state) => state.socket);
	const liveId = useStore((state) => state.liveId);
	const [inputValue, setInputValue] = useState("");

	useEffect(() => {
		if (listenerFullName.trim() !== "") return;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, [listenerFullName]);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const trimmedName = inputValue.trim();
		if (trimmedName !== "") {
			setListenerFullName(trimmedName);
			if (socket?.readyState === WebSocket.OPEN && liveId != null) {
				socket.send(
					JSON.stringify({
						type: SocketEvents.participantJoined,
						data: {
							fullName: trimmedName,
							liveId,
							joinedAt: new Date().toISOString(),
						},
					})
				);
			}
		}
	};

	if (listenerFullName.trim() !== "") return null;
	if (status === 1) return null;

	return (
		<div
			className="fixed inset-0 z-[9999] flex items-center justify-center overflow-auto bg-black/80 p-4"
			style={{ pointerEvents: "auto" }}
		>
			<div
				className="relative z-10 w-full max-w-md rounded-lg bg-rteSecondary p-6 shadow-lg"
				onClick={(e) => e.stopPropagation()}
			>
				<h2 className="mb-2 text-lg font-semibold text-secondary">
					{t("live_page.full_name_modal_title")}
				</h2>
				<p className="mb-4 text-sm text-secondary">
					{t("live_page.full_name_modal_message")}
				</p>
				<form onSubmit={handleSubmit} className="flex flex-col gap-4">
					<Input
						icon={NameIcon}
						value={inputValue}
						setValue={setInputValue}
						title={t("signup_page.full_name")}
						type="text"
					/>
					<button
						type="submit"
						className="w-full rounded-lg bg-rte p-3 font-medium text-primary"
					>
						{t("live_page.continue")}
					</button>
				</form>
			</div>
		</div>
	);
};

export default FullNameModal;
